import React from 'react'
import { Timeline, Upload, Table } from '@bedrock/components'
import moment from "moment";
import './index.less'
import NewPendingQuote from "#features/NewPendingQuote";



export default function HistoryListStructured({ list = [], isInner = true, detail }: {
  detail: any,
  list: any[],
  isInner?: boolean,
}) {
  return (<div className={'sm-history-list'}>
    <Timeline className={'time-line'}>
      {
        list?.reverse()?.map((item: any, index) => {
          return (
            <Timeline.Item
              key={index}
              title={`第 ${item.turns_number} 轮报价`}
              desc={
                <div style={{ 'wordBreak': 'break-all' }}>
                  {moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') || '--'}
                  <br />
                  <span>退回原因：</span><span style={{ color: '#1E1D29' }}>{item.re_quotation_reason || '--'}</span>
                </div>}
              status={index === 0 ? 'done' : 'default'}
            >
              <NewPendingQuote
                view={true}
                value={item}
                detail={detail}
                type='history'
                supplierQuotationTableConfig={item}
              />
            </Timeline.Item>
          )
        })
      }
    </Timeline>
  </div>)
}
